import { render, staticRenderFns } from "./auto-transition.vue?vue&type=template&id=1b6ce222"
import script from "./auto-transition.vue.ts?vue&type=script&lang=js&external"
export * from "./auto-transition.vue.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports